import { useFormikContext } from "formik";

import UploadFileField from "./UploadFileField";
import Document from "../../../components/uploadDocumentForm/Document";
import { useEffect, useState } from "react";

const DocumentUpload = ({ name, multiple, fileLimit, options, acceptedTypes, clearFiles, onFileSelect, getFiles }) => {
  const { values, setFieldValue } = useFormikContext();
  const [internalClearFiles, setInternalClearFiles] = useState(clearFiles);
  
  useEffect(() => {
    if (clearFiles) {
      setFieldValue(name, []); 
      setInternalClearFiles(false); 
    }
  }, [clearFiles, name, setFieldValue]);

  useEffect(() => {
    getFiles && getFiles(values)
    console.log("Formik values in DocumentUpload:", values[name]);
  }, [values]);

  return (
    <>
      <UploadFileField
        name={name}
        multiple={multiple}
        fileLimit={fileLimit}
        acceptedTypes={acceptedTypes}
        onFileSelect={onFileSelect}
        files={
          <div className="my-4">
            {values[name]?.map((value, idx) => {
              return (
                <div
                  className={values[name].length - 1 === idx ? "" : "mb-3"}
                  key={idx}
                >
                  <Document
                    idx={0}
                    fieldName="documents"
                    fileName="sample.pdf"
                    fileSize={1024}
                    onRemoveDocument={() =>
                      setFieldValue(
                        name,
                        values[name].filter((_, fileIdx) => fileIdx !== idx)
                      )
                    }
                    options={options}
                  />
                </div>
              );
            })}
          </div>
        }
      />
    </>
  );
};

export default DocumentUpload;
